import React, { useEffect, useState } from "react";
import api from "../lib/api";
import Reveal from "../components/Reveal";
import { Loader2, ImageOff } from "lucide-react";

export default function Gallery() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="gallery-page" className="pt-32 pb-24 max-w-7xl mx-auto px-5 sm:px-8 min-h-screen">
      <Reveal>
        <div className="label-caps mb-3">Our Work</div>
        <h1 className="font-display text-6xl sm:text-7xl tracking-tighter mb-4">The Gallery</h1>
        <p className="text-gray-400 max-w-xl text-lg">Fresh cuts, sharp fades and clean finishes straight from the chair.</p>
      </Reveal>

      {items === null ? (
        <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 text-[#D4AF37] animate-spin" /></div>
      ) : items.length === 0 ? (
        <div className="flex flex-col items-center py-24 text-gray-500">
          <ImageOff className="w-12 h-12 mb-4" /> No photos yet — check back soon.
        </div>
      ) : (
        <div className="mt-16 columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {items.map((g, i) => (
            <Reveal key={g.id} delay={(i % 3) * 0.08}>
              <div className="relative overflow-hidden rounded-2xl group break-inside-avoid">
                <img src={g.url} alt={g.caption} loading="lazy" className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                  <span className="text-white text-sm">{g.caption}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
}
